var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }